const carPosition = (state=0,action)=>{
    switch(action.type){
        case "JUMP":
            if(state===15)
            return state;
            else
            return state+15;
        case "LOWER":
            if(state===0)
            return state;
            else
            return state-15;
        default:
            return 0;
    }
}

export default carPosition;